import React, { Component } from 'react';

let plyr;

class PlyrComponent extends Component {
  componentWillMount() {
    let id;
    if (this.props.videoData.vimeo_id) {
      id = this.props.videoData.vimeo_id;
    } else if (this.props.videoData.youtube_id) {
      id = this.props.videoData.youtube_id;
    } else if (this.props.videoData.video_file) {
      id = this.props.videoData.video_file.id
        ? this.props.videoData.video_file.id
        : this.props.videoData.video_file.url;
    }
    this.videoId = id;
  }

  componentDidMount() {
    if (typeof document !== 'undefined') {
      plyr = require('plyr');
    }
    this.plyr = plyr.setup(`#player-${this.videoId}`, this.props.options);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isVideoOpen !== this.props.isVideoOpen) {
      if (this.props.isVideoOpen) {
        this.plyr[0].play();
      } else {
        this.plyr[0].stop();
      }
    }
  }

  // plyr has a bug where destroy on unmount throws an error.
  // we'll see if we run into any issue here.
  // componentWillUnmount() {
  //   if (this.plyr[0] && this.plyr[0].destroy) {
  //     this.plyr[0].stop();
  //     this.plyr[0].destroy();
  //   }
  // }

  render() {
    return (
      <div style={{ height: this.props.isChapter ? '100%' : '' }}>
        {this.props.videoData.video_source === 'vimeo' && (
          <div className="plyr__video-embed" id={`player-${this.videoId}`}>
            <iframe
              src={`https://player.vimeo.com/video/${
                this.videoId
              }?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`}
              allowFullScreen
              allowtransparency="true"
              allow="autoplay"
            />
          </div>
        )}

        {this.props.videoData.video_source === 'youtube' && (
          <div className="plyr__video-embed" id={`player-${this.videoId}`}>
            <iframe
              src={`https://www.youtube.com/embed/${
                this.videoId
              }?iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`}
              allowFullScreen
              allowtransparency="true"
              allow="autoplay"
            />
          </div>
        )}

        {this.props.videoData.video_source === 'mp4_upload' && (
          <video
            poster={this.props.videoData.image.url}
            id={`player-${this.videoId}`}
            playsInline
            controls
          >
            <source
              src={this.props.videoData.video_file.url}
              type="video/mp4"
            />
          </video>
        )}
      </div>
    );
  }
}

export default PlyrComponent;



// WEBPACK FOOTER //
// ./src/components/global/PlyrComponent.js